import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
  } from "@mui/material";
  
  import { Formik, Form, Field } from "formik";
import { useDispatch } from "react-redux";
import { UpdatePassword } from "store/slice/usersSlice";
import * as Yup from "yup";
  
  // Yup validation schema
  const passwordValidationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Current password is required"),
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .oneOf(
        [Yup.ref("currentPassword")],
        "New password must be different from current password"
      )
      .required("New password is required"),
  });
  
  const UpdatePasswordModal = ({ setPasswordModalOpen, passwordModalOpen }) => {
    const dispatch = useDispatch();
    
    const handleClose = () => {
      setPasswordModalOpen(false);
    };
  
    const handleSubmit = (values) => {
      setPasswordModalOpen(false);
        const token = localStorage.getItem('auth-token');
        dispatch(UpdatePassword({password: values.currentPassword, token: token}))
      // Add your API call or password update logic here
    };
  
    return (
      <Dialog open={passwordModalOpen} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>Change Password</DialogTitle>
  
        <Formik
          initialValues={{
            currentPassword: "",
            newPassword: "",
          }}
          validationSchema={passwordValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, handleChange, handleBlur, values }) => { 
     
            return(
            <Form>
              <DialogContent>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Current Password"
                  name="currentPassword"
                  type="password"
                  value={values.currentPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.currentPassword && Boolean(errors.currentPassword)}
                  helperText={touched.currentPassword && errors.currentPassword}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label="New Password"
                  name="newPassword"
                  type="password"
                  value={values.newPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.newPassword && Boolean(errors.newPassword)}
                  helperText={touched.newPassword && errors.newPassword}
                />
              </DialogContent>
  
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}}
        </Formik>
      </Dialog>
    );
  };
  
  export default UpdatePasswordModal;
  